import { render, staticRenderFns } from "./AlvaroContactsTab.vue?vue&type=template&id=9727fe36"
import script from "./AlvaroContactsTab.vue?vue&type=script&lang=js"
export * from "./AlvaroContactsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports